/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Print_All_DocumentsInputs */

const en_orders_print_all_documents = /** @type {(inputs: Orders_Print_All_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Print All`)
};

const es_orders_print_all_documents = /** @type {(inputs: Orders_Print_All_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imprimir todo`)
};

/**
* | output |
* | --- |
* | "Print All" |
*
* @param {Orders_Print_All_DocumentsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_print_all_documents = /** @type {((inputs?: Orders_Print_All_DocumentsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Print_All_DocumentsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_print_all_documents(inputs)
	return es_orders_print_all_documents(inputs)
});